import { styled } from "twin.macro";

export const Dropdown = styled.div(({ type }) => {

  const isLangSelect = type === "lang";
  const langStyles = `
    .dropdown {
      border: 1px solid #006FCF;
      color: #006FCF;
    }
    .selected-option {
      color: #006FCF;
    }
  `;

  return [
    isLangSelect
      ? langStyles
      : `
    .dropdown {
      border: 1px solid #ccc;
    }
    `,
    `
      position: relative;
      display: inline-block;
      width: 100%;
      margin: 1rem 0;

      .dropdown {
        cursor: pointer;
        background: #fff;
        border-radius: 4px;
        padding: 0.5rem;
        font-size: 1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: rgba(63,63,70);
        margin: 0px 1rem;

        .selected-option {
          display: flex;
          align-items: center;

          div {
            margin-right: 0.5rem;
          }
        }
      }

      .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        width: calc(100% - 2rem);
        background: #fff;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
        z-index: 10;
        overflow: hidden;
        margin: 0px 1rem;
      }
    `,
  ];
});

export const DropdownItem = styled.div`
  padding: 0.5rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  background: "#fff";
  color: ${({ active }) => (active ? "#8E9092" : "#007bff")};
  cursor: ${({ active }) => (active ? "default" : "pointer")};
  transition: background 0.3s, color 0.3s;

  &:hover {
    background: ${({ active }) => (active ? "#fff" : "#f0f0f0")};
  }

  div {
    margin-right: 0.5rem;
  }
`;
